module.exports = __webpack_public_path__ + "h5/img/stores1.a58e2bf0.jpg";